import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IRiskStandardEditItem extends IEditItem {
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
    modifyUser: IModifyUser;
}

export class RiskStandardEditItem extends EditItem implements IRiskStandardEditItem {
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IRiskStandardEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}

export type TRiskStandardEditItemNewSave = {
    id: string;
    code: string;
    comment: string;
    sortOrder: number;
    activeState: number;
}